export default __webpack_public_path__ + "static/media/recipeguide-icon.8b80debc.svg";